import exampleEditItemTpl from '../templates/creative_preview/example_edit_item.directive.html';

function ExampleEditItemController(ExamplesService, $sce) {
  const vm = this;

  vm.deleteExample = deleteExample;
  vm.safeHtml = safeHtml;

  function deleteExample(id) {
    return ExamplesService.deleteExample(id);
  }

  function safeHtml(html) {
    return $sce.trustAsHtml(html);
  }

  return vm;
}

ExampleEditItemController.$inject = ['ExamplesService', '$sce'];

export default function strExampleEditItem() {
  return {
    template: exampleEditItemTpl,
    controller: ExampleEditItemController,
    controllerAs: 'exEditCtrl',
    bindToController: true,
    scope: {
      example: '='
    }
  };
}
